const LINKS_KEY = 'jarvis.documentEditor.textLinksVisible';

function readBool(key: string, defaultValue = true): boolean {
  try {
    const v = localStorage.getItem(key);
    if (v === '0') return false;
    if (v === '1') return true;
  } catch {
    /* ignore */
  }
  return defaultValue;
}

function writeBool(key: string, value: boolean): void {
  try {
    localStorage.setItem(key, value ? '1' : '0');
  } catch {
    /* ignore */
  }
}

export function readDocumentTextLinksVisible(): boolean {
  return readBool(LINKS_KEY, true);
}

export function writeDocumentTextLinksVisible(visible: boolean): void {
  writeBool(LINKS_KEY, visible);
}
